<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { onMount, onDestroy } from 'svelte';
    import Self from './ItemBlocks.svelte';

    import blockTypes from './blockTypes.js';

    //the block tree that contains data to render, by type,
    //either some html, text or a component
    // prettier-ignore
    let {
        blockTree = [],
        onmount,
        ondestroy
    } = $props();

    onMount(() => {
        onmount?.();
    });

    onDestroy(() => {
        ondestroy?.();
    });
</script>

{#each blockTree as block, idx (idx)}
    {#if block.type === blockTypes.html}
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html block.content}
    {:else if block.type === blockTypes.text}
        {block.content}
    {:else if block.type === blockTypes.container || block.type === blockTypes.element}
        {@const BlockComponent = block.component}
        <BlockComponent {...block.props}>
            {#if block.children}
                <Self blockTree={block.children} />
            {/if}
        </BlockComponent>
    {/if}
{/each}
